import React, { useEffect, useState } from "react";
import { SVG_LIBRARY, SvgAsset } from "~components/Svg";
import Link from "~components/Link";
import ResponsiveImage from "~components/ResponsiveImage";
import { useMediaQuery } from "~hooks/useMediaQuery";
import styles from "./index.module.scss";
import cn from "classnames";

const Footer = (props) => {
  const footerData = props.pageData?.footer;
  const isDesktop = useMediaQuery();
  const [tooltip, setTooltip] = useState(null);

  const handleSmClick = (e, index, type = 'link', popupMobile = false) => {
    if (isDesktop || popupMobile) {
      if (type !== 'link') {
        e.preventDefault()
        setTooltip(index)
      }
    }
  };

  useEffect(() => {
    document.body.addEventListener("click", closeTooltip);

    return () => {
      document.body.removeEventListener("click", closeTooltip);
    };
  }, []);

  const closeTooltip = (e) => {
    const aTag = e.target.closest("a");
    const spanTag = e.target.closest("span");
    if (
      (aTag === null ||
        (aTag &&
          !aTag.classList
            .toString()
            .includes("onvoFooterSocialMediaItemAtag") &&
          aTag &&
          !aTag.classList.toString().includes("footerTooltipItem"))) &&
      (spanTag === null ||
        (spanTag &&
          !spanTag.classList.toString().includes("footerTooltipItem")))
    ) {
      setTooltip(null);
    }
  };

  return (
    <div className={styles.onvoFooter}>
      <div
        className={cn(styles.onvoFooterInner, "grid-container-grid grid-row")}
      >
        {footerData?.socialMedia && (
          <div className={styles.onvoFooterSocialMedia}>
            {footerData.socialMedia.map((smItem, index) => {
              return (
                <span key={index} className={styles.onvoFooterSocialMediaItem}>
                  <Link
                    className={"onvoFooterSocialMediaItemAtag"}
                    href={smItem.href}
                    title={smItem.title}
                    onClick={(e) => { handleSmClick(e, index, smItem.type, smItem.popupMobile) }}
                  >
                    { SVG_LIBRARY[smItem.icon] }
                  </Link>
                  {((isDesktop && smItem.type && smItem.type === 'popup') || smItem.popupMobile) && (
                    <Tooltip customClass={{[styles.active]: tooltip === index}} smItem={smItem} />
                  )}
                </span>
              );
            })}
          </div>
        )}
        {footerData?.privacyLegal && (
          <div className={styles.onvoFooterPrivacyLegal}>
            {footerData?.privacyLegal.map((plItem, index) => {
              return (
                <Link
                  key={index}
                  href={plItem.href}
                  className={styles.onvoFooterPrivacyLegalItem}
                >
                  {plItem.title}
                </Link>
              );
            })}
          </div>
        )}
        {footerData?.copyright && (
          <div className={styles.onvoFooterCopyright}>
            {footerData?.copyright.map((crItem, index) => {
              const label =
                (crItem === "year" ? new Date().getFullYear() : crItem) + " ";
              return (
                <span key={index} dangerouslySetInnerHTML={{ __html: label }} />
              );
            })}
          </div>
        )}
        {footerData?.icp && (
          <div className={styles.onvoFooterIcp}>
            {footerData?.icp.map((icpItem, index) => {
              return icpItem.id === "icpLogo" ? (
                <Link
                  key={index}
                  className={styles.onvoFooterIcpItem}
                  href={icpItem.href}
                >
                  <SvgAsset customClass={styles.onvoFooterIcpLogo} svgId={icpItem.icon} />
                </Link>
              ) : (
                <Link
                  key={index}
                  href={icpItem.href}
                  alt={icpItem.label}
                  className={!icpItem.href ? styles.onvoFooterIcpItem : ""}
                  dangerouslySetInnerHTML={{ __html: icpItem.label }}
                >
                  {icpItem.label}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const Tooltip = ({ customClass = "", smItem = {} }) => {
  if (smItem.length === 0) {
    return <></>;
  }
  return (
    <div className={cn(styles.footerTooltip, customClass)}>
      {smItem.content?.type === "svg" ? (
        <SvgAsset
          customClass={"footerTooltipItem"}
          svgId={smItem.content.data}
        />
      ) : smItem.content?.type === "image" ? (
        <ResponsiveImage className={styles.footerTooltipImg} {...smItem.content.image} />
      ) : smItem.content?.type === "phone" ? (
        <a
          className={"footerTooltipItem"}
          title={smItem.content?.data || "contact phone"}
          href={`tel:${smItem.content?.data}` || ""}
          dangerouslySetInnerHTML={{ __html: smItem.content?.data || "" }}
          rel="noindex nofollow"
        />
      ) : (
        <span
          className={"footerTooltipItem"}
          dangerouslySetInnerHTML={{ __html: smItem.content?.data || "" }}
        />
      )}
    </div>
  );
};

export default Footer;
